<template>
  <form @submit.prevent="$emit('submit')" novalidate="true" autocomplete="off">
    <form-field
      full-width
      required
      label="Category Name"
      name="category_name"
      :max-length="45"
      show-counter
      helper-text="Please enter a name for your category (45 characters max)"
      v-validate="'required|min:2'"
      data-vv-as="category name"
      :error="errors.first('category_name')"
      v-model="newsCategory.name"
    ></form-field>

    <form-field
      full-width
      required
      label="Category Description"
      name="category_description"
      helper-text="Please enter a description for your category"
      v-validate="'required|min:2'"
      data-vv-as="category description"
      :error="errors.first('category_description')"
      v-model="newsCategory.description"
      type="textarea"
    ></form-field>
  </form>
</template>

<script>
import { createHelpers } from 'vuex-map-fields';

export default {
  name: 'category-form',
  props: [
    'newsCategory',
  ],

  computed: {
    category: {
      get() {
        return this.$store.state.categories.currentCategory;
      },
      set(value) {
        this.$store.commit('categories/setCurrentCategory', value);
      },
    },
  },
};
</script>
